export const defaultItems = [
  {
    percentage: 84,
    text: "of edX learners have seen positive professional growth after earning a certificate.",
    source: "Source: edX certificate satisfaction survey results",
    showItem: true,
  },
  {
    percentage: 57,
    text: "of edX learners felt that earning a certificate strengthened their resume.",
    source: "Source: edX certificate satisfaction survey results",
    showItem: true,
  },
];
